module.exports = __webpack_public_path__ + "static/media/logoRemu.74cc783e.jpeg";